<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 12.5616L12.0372 4.53562C13.0218 3.55238 14.3573 3 15.7497 3C17.1422 3 18.4776 3.55238 19.4622 4.53563C20.4468 5.51887 21 6.85243 21 8.24295C21 9.63346 20.4468 10.967 19.4622 11.9503L11.425 19.9763C10.7686 20.6317 9.87832 21 8.95001 21C8.0217 21 7.13142 20.6317 6.475 19.9763C5.81859 19.3208 5.44982 18.4317 5.44982 17.5047C5.44982 16.5777 5.81859 15.6886 6.47501 15.0332L14.521 7.00717C14.8492 6.67943 15.2943 6.4953 15.7585 6.4953C16.2226 6.4953 16.6678 6.67943 16.996 7.00717C17.3242 7.33492 17.5086 7.77944 17.5086 8.24295C17.5086 8.70645 17.3242 9.15097 16.996 9.47872L9.57095 16.8846" stroke="#233780" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AppendFileIcon'
}
</script>
